/* eslint-disable import/no-cycle */
import { Stack, HStack } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormLabelInput from '../formInputs/FormLabelInput';
import FormOptions from '../formInputs/FormOptions';
import FormTextInput from '../formInputs/FormTextInput';
import { FormBuilderComponentProps } from '../types';

function MultiChoiceFieldComponent({ fieldId, isAdvanced, labelRightRenderer }: Omit<FormBuilderComponentProps, 'path'>) {
  const { t } = useTranslation('hrFormTemplate');

  return (
    <Stack>
      <HStack justify="space-between">
        <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
        {labelRightRenderer}
      </HStack>

      <FormTextInput
        fieldId={fieldId}
        placeholder={t('formBuilder.editorPlaceholder.checkbox')}
        isAdvanced={isAdvanced || false}
      />
      <FormOptions type="checkbox" fieldId={fieldId} />
    </Stack>
  );
}

export const MultiChoiceField = React.memo(
  MultiChoiceFieldComponent,
  (prev, next) =>
    /* eslint-disable-next-line  */
    prev.fieldId === next.fieldId && prev.isAdvanced === next.isAdvanced && prev.labelRightRenderer === next.labelRightRenderer,
);
